import React from "react";
import PropTypes from "prop-types";
import { Headline } from "../../atoms/headline";
import AuthorWithTime from "../author-with-time";
import { SectionName } from "../../atoms/section-tag";
import { CardImage } from "../../atoms/card-image";
import { Subheadline } from "../../atoms/subheadline";

import "./common-story-card.m.css";

const CommonStoryCard = ({
  story = {},
  showSection = false,
  showAuthorWithTime = true,
  showSubHeadline = false,
  hideAuthor = false
}) => {
  return (
    <div styleName="card-container">
      <CardImage story={story} />
      <div styleName="text-wrapper">
        {showSection && <SectionName story={story} />}
        <Headline story={story} externalLink={true} />
        {showSubHeadline && <Subheadline story={story} />}
        {showAuthorWithTime && <AuthorWithTime story={story} hideAuthor={hideAuthor} />}
      </div>
    </div>
  );
};

CommonStoryCard.propTypes = {
  story: PropTypes.object,
  showSection: PropTypes.bool,
  showAuthorWithTime: PropTypes.bool,
  showSubHeadline: PropTypes.bool,
  hideAuthor: PropTypes.bool
};

export default CommonStoryCard;
